var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NumberInput, UnControlledFormField } from '../../common';
var CODE_PATTERN = /^[A-Z0-9]{1,10}$/;
export var AddCustomCurrencyDialog = function (_a) {
  var open = _a.open,
    rollupCurrency = _a.rollupCurrency,
    existingCodes = _a.existingCodes,
    onClose = _a.onClose,
    onSave = _a.onSave;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'financials'
  }).t;
  var _b = useState(''),
    name = _b[0],
    setName = _b[1];
  var _c = useState(''),
    rate = _c[0],
    setRate = _c[1];
  var _d = useState(null),
    nameError = _d[0],
    setNameError = _d[1];
  var _e = useState(null),
    rateError = _e[0],
    setRateError = _e[1];
  var _f = useState(false),
    saving = _f[0],
    setSaving = _f[1];
  useEffect(function () {
    if (!open) return;
    setName('');
    setRate('');
    setNameError(null);
    setRateError(null);
  }, [open]);
  var handleSave = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var code, knownCodes, hasError, rateNum;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            code = name.trim().toUpperCase();
            knownCodes = new Set(existingCodes.map(function (c) {
              return c.trim().toUpperCase();
            }));
            hasError = false;
            if (!CODE_PATTERN.test(code)) {
              setNameError(String(t('customCurrency.nameError', {
                defaultValue: 'Enter up to 10 letters or numbers, no spaces.'
              })));
              hasError = true;
            } else if (knownCodes.has(code)) {
              setNameError(String(t('customCurrency.nameDuplicate', {
                defaultValue: '{{code}} already exists.',
                code: code
              })));
              hasError = true;
            } else {
              setNameError(null);
            }
            rateNum = Number.parseFloat(rate);
            if (!rate || Number.isNaN(rateNum) || rateNum < 0.0001) {
              setRateError(String(t('conversion.rateMinError', {
                defaultValue: 'Rate must be at least 0.0001'
              })));
              hasError = true;
            } else {
              setRateError(null);
            }
            if (hasError) return [2 /*return*/];
            setSaving(true);
            _a.label = 1;
          case 1:
            _a.trys.push([1,, 3, 4]);
            return [4 /*yield*/, onSave({
              currencyCode: code,
              corporateOverrideRate: rate
            })];
          case 2:
            _a.sent();
            onClose();
            return [3 /*break*/, 4];
          case 3:
            setSaving(false);
            return [7 /*endfinally*/];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  return _jsxs(Dialog, __assign({
    open: open,
    onClose: onClose,
    maxWidth: "xs",
    fullWidth: true
  }, {
    children: [_jsx(DialogTitle, __assign({
      variant: "h1"
    }, {
      children: t('customCurrency.title', {
        defaultValue: 'Add Custom Currency'
      })
    })), _jsx(DialogContent, {
      children: _jsxs(Stack, __assign({
        spacing: 3,
        sx: {
          pt: 1
        }
      }, {
        children: [_jsx(Typography, {
          children: t('customCurrency.help', {
            defaultValue: 'Enter a name for this currency and the corporate exchange rate to use for it.'
          })
        }), _jsx(UnControlledFormField, __assign({
          label: String(t('customCurrency.name', {
            defaultValue: 'Currency Name'
          })),
          required: true,
          errorMessage: nameError !== null && nameError !== void 0 ? nameError : undefined
        }, {
          children: _jsx(TextField, {
            fullWidth: true,
            value: name,
            placeholder: String(t('customCurrency.namePlaceholder', {
              defaultValue: 'e.g. XYZ'
            })),
            inputProps: {
              maxLength: 10,
              style: {
                textTransform: 'uppercase'
              }
            },
            error: Boolean(nameError),
            onChange: function (e) {
              setName(e.target.value);
              setNameError(null);
            }
          })
        })), _jsx(UnControlledFormField, __assign({
          label: String(t('customCurrency.rate', {
            defaultValue: 'Corporate Exchange Rate (per {{rollup}})',
            rollup: rollupCurrency
          })),
          required: true,
          errorMessage: rateError !== null && rateError !== void 0 ? rateError : undefined
        }, {
          children: _jsx(NumberInput, {
            fullWidth: true,
            min: 0,
            max: 999999,
            decimal: 4,
            value: rate,
            error: Boolean(rateError),
            onChange: function (v) {
              setRate(v == null ? '' : String(v));
              setRateError(null);
            }
          })
        }))]
      }))
    }), _jsxs(DialogActions, __assign({
      sx: {
        justifyContent: 'space-between'
      }
    }, {
      children: [_jsx(Button, __assign({
        variant: "outlined",
        onClick: onClose,
        disabled: saving
      }, {
        children: t('conversion.close', {
          defaultValue: 'CLOSE'
        })
      })), _jsx(Button, __assign({
        variant: "contained",
        onClick: handleSave,
        disabled: saving
      }, {
        children: t('conversion.save', {
          defaultValue: 'SAVE'
        })
      }))]
    }))]
  }));
};